module.exports = __webpack_public_path__ + "img/credit-score-managment-1.c994f2bf.png";